import React from 'react';
import { MenuItem, NavDropdown } from 'react-bootstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import UserIcon from '../../../static/images/icon-user.svg';
import { modal } from '../../../store/actions';
import { logout } from '../../../utils/apputils';
import { purchaseCredits } from '../../../utils/google';

const ProfileMenu_Class = ({ user, dispatch, credits }) => {
  const menuSelected = (key, e) => {
    e.preventDefault();
    switch (key) {
      case 'logout':
        logout(user, dispatch);
        break;
      case 'billing':
        dispatch(modal.showModal());
        break;
      default:
    }
  };

  return (
    <ul className="nav navbar-nav navbar-right">
      <NavDropdown
        id="nav-dropdown"
        className="btn btn-account"
        eventKey="menu"
        title={
          <div id="accountBtn">
            <img className="icon-user" src={UserIcon} alt="" />
            {credits} Credits
          </div>
        }
      >
        <MenuItem
          eventKey="billing"
          onSelect={menuSelected}
          onClick={purchaseCredits}
          active={false}
        >
          Purchase credits
        </MenuItem>
        <LinkContainer to="/profile" isActive={() => false}>
          <MenuItem id="profile">Your account</MenuItem>
        </LinkContainer>
        <LinkContainer to="/library" isActive={() => false}>
          <MenuItem id="library">Your pics</MenuItem>
        </LinkContainer>
        <LinkContainer to="/orders" isActive={() => false}>
          <MenuItem id="orders">Your orders</MenuItem>
        </LinkContainer>
        <LinkContainer
          eventKey="logout"
          onSelect={menuSelected}
          to="/"
          isActive={() => false}
        >
          <MenuItem>Log out</MenuItem>
        </LinkContainer>
      </NavDropdown>
    </ul>
  );
};

const mapStateToProps = state => ({
  user: state.users.user,
  given_name: state.users.given_name,
  email: state.users.email,
  credits: state.users.credits
});
const ProfileMenu = connect(mapStateToProps)(ProfileMenu_Class);

export default ProfileMenu;



// WEBPACK FOOTER //
// ./src/comps/Navbar/components/ProfileMenu.js